const formatMoney = (money) => {
  if (!money) return 0;
  const formattedNumber = money
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return formattedNumber;
};

export { formatMoney };
